import { render } from "./TableForm.vue?vue&type=template&id=bd88ccb4&ts=true"
import script from "./TableForm.vue?vue&type=script&lang=ts"
export * from "./TableForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__